import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import UIButton from "../buttons/UIButton";
import { usePathname } from "next/navigation";

import styles from "./SearchBox.module.css";

interface ISearchBox {
  label?: string;
  placeholder?: string;
  value: string;
  onChange: (search: string) => void;
  onClickSearch: () => void;
  withoutButton?: boolean;
  classes?: {
    root?: string;
    paper?: string;
    iconButton?: string;
    searchIcon?: string;
    inputBase?: string;
    button?: string;
  };
  className?: string;
}

const SearchBox = ({
  label,
  placeholder,
  value,
  onChange,
  onClickSearch,
  withoutButton,
  classes,
}: ISearchBox) => {
  const handleOnChanghe = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (onChange) onChange(val);
  };
  const handleOnSearch = () => {
    if (onClickSearch) onClickSearch();
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (onClickSearch) onClickSearch();
    }
  };
  const pathname = usePathname();

  return (
    <div key={label} className={`${styles.root} ${classes?.root}`}>
      <Paper classes={{ root: `${styles.paper} ${classes?.paper}` }} className={((pathname == "/operations") || (pathname == "/operations/records")) ? styles.largeSearchBox : ''}>
        <IconButton onClick={handleOnSearch}
          className={`${classes?.iconButton}`}
          sx={{ p: "10px" }}
          aria-label="menu"
        >
          <SearchIcon className={`${classes?.searchIcon}`} />
        </IconButton>
        <InputBase
          className={`${classes?.inputBase} ${((pathname == "/operations") || (pathname == "/operations/records")) ? styles.largeSearchBoxInput : ''}`}
          placeholder={placeholder}
          value={value}
          onKeyDown={handleKeyDown}
          onChange={handleOnChanghe}
        />
      </Paper>
      {!withoutButton && (
        <UIButton
          color="secondary"
          label="Buscar"
          onClick={handleOnSearch}
          sx={{
            padding: "16px",
            '@media (max-width:1199px)': {
              padding: "16px 12px",
            }
          }}
          //disabled={!value}
        />
      )}
    </div>
  );
};

export default SearchBox;
